let wlCasinoId = 'ppcdx00000006331';
import Vue from 'vue'
import store from '../store';
export const dgaSocket = {
	websocket : null,
	wsUri : null,
	tableId : null,
	debug : true,
	casinoId : null,
	tryToConnect : true,

	// public
	connect : function(wsUri, casinoId, tableId) {
		var self = this;
		self.tryToConnect = true;
		self.wsUri = wsUri;
        if(self.debug){
    		console.log('connecting to ' + 'wss://' + wsUri + '/ws');
        }
		if(self.websocket !== null && self.websocket.readyState !== 3){
			self.websocket.close();
            if(self.debug){
                console.log('Socket open closing it');
            }
		} 
		self.websocket = new WebSocket('wss://' + wsUri + '/ws');
		self.websocket.onopen = function(evt) {
			self.onWsOpen(evt, casinoId, tableId)
		};
		self.websocket.onclose = function(evt) {
			self.onWsClose(evt)
		};
		self.websocket.onmessage = function(evt) {
			self.onWsMessage(evt)
		};
		self.websocket.onerror = function(evt) {
			self.onWsError(evt)
		};
		if (tableId) {
			self.tableId = tableId;
		}
		self.casinoId = casinoId;
	},
	// public
	onMessage : function(data) {
		// to fill
	},
	// public
	onConnect : function() {
		// to fill
	},
	// public
	disconnect : function() {
		var self = this;
		self.tryToConnect = false;
		self.websocket.close();
        if(self.debug){
            console.log('Disconnected');
        }
	},
	// public
	subscribe : function(casinoId, tableId, currency) {
		var subscribeMessage = {
			type : 'subscribe',
			key : tableId,
			casinoId : casinoId,
			currency : currency
		}

		var self = this;
		// console.log('Subscribing ' + tableId);
		var jsonSub = JSON.stringify(subscribeMessage);
		self.doWsSend(jsonSub);
	},
	
	// public
	available : function(casinoId) {
		var availableMessage = {
			type : 'available',
			casinoId : casinoId
		}

		var self = this;
		// console.log('Subscribing ' + tableId);
		var jsonSub = JSON.stringify(availableMessage);
		self.doWsSend(jsonSub);
	},

	onWsOpen : function(evt) {
		var self = this;

		// console.log(evt.data);
		if (self.onConnect != null) {
			self.onConnect();
		}
		dgaSocket.available(wlCasinoId)
		if (self.tableId) {
			self.subscribe(self.casinoId, self.tableId)
		}
	},

	onWsClose : function(evt) {
        if(self.debug){
            console.log('Disconnected');
        }
		var self = this;
		if (self.tryToConnect === true) {
            if(self.debug){
                console.log("RECONNECTING");
            }
			self.connect(self.wsUri, self.casinoId, self.tableId);
		}
	},

	onWsMessage : function(evt) {
		var self = this;
		var data = JSON.parse(evt.data);
		if(data.tableKey){
            _.forEach(data.tableKey, function(tableId) {
                dgaSocket.subscribe(wlCasinoId,tableId, 'TRY');
            });
        }
        if(data.tableId){
            let payload = {
                id : data.tableId,
                details: data
            }
            store.commit('casino/setGameDetail', payload)
        }
		if (self.onMessage != null) {
			self.onMessage(data);
		}
	},

	onWsError : function(evt) {
		console.log('ERROR: ' + evt.data);
	},

	ping : function() {
    	var self = this;
    	var pingMessage = {
            type : 'ping',
            pingTime : Date.now().toString()
        }
        var jsonSub = JSON.stringify(pingMessage);
        self.doWsSend(jsonSub);
    },

	doWsSend : function(message) {
		var self = this;
		self.websocket.send(message);
	}
};

